
export const handleListFilter = (f, p) => {
    if (!f) return null
    const arr = []
    f.map(e => {
        const rxp = /([a-zA-Z]+)\|{2}(\$[a-z]+)\|{2}(\{{2})?([a-zA-Z]+)(\}{2})?/gi
        const r = rxp.exec(e)
        if (!!p[r[4]]) {
            arr.push(`${r[1]}||${r[2]}||${p[r[4]]}`)
        } else {
            arr.push(e)
        }
    })
    return arr
}

export const handleExtraUrl = (e, p) => {
    if (!e) return null
    const rxp = /([a-zA-Z]+)\|{2}(\{{2})?([a-zA-Z0-9]+)(\}{2})?/gi
    const r = rxp.exec(e)

    if (!!p && !!p[r[3]]) return `${[r[1]]}/${p[r[3]]}`
    return `${[r[1]]}/${r[3]}`
}